import { JourneyTrack } from "../journey-track";
import { TrackTypes } from "../model/track-types";
import { TrackInfo } from "../model/track-info";
import { TrackActionResult } from "../model/track-action-result";
import { UpdateRegistrationFactoryService } from "../../../update-registration/update-registration-factory-service";
import { DataOrigin } from "../../../../../shared/model/DataOrigin";
import { DomainOrigin } from "../../../user-signup/model/domain-origin";
import { environment } from "../../../../../../environments/environment";
import { UserRegistrationParseData } from "../cadastro-investidor-v2/util/user-registration-parse-data";

export class UpdateRegistrationTrack extends JourneyTrack {
  readonly originalTracks = [
    new TrackInfo("client-data", ["data", "client-data"], undefined, {
      dataOrigin: DomainOrigin[environment.updateRegistration],
    }),
    new TrackInfo("broker", ["broker"]),
    new TrackInfo("terms", ["terms"], undefined, {
      dataOrigin: DomainOrigin[environment.updateRegistration],
    }),
  ];

  track = this.originalTracks;
  registratioJourney: any;
  dataOrigin = DataOrigin.Mobile;

  constructor(
    private updateRegistrationFactory: UpdateRegistrationFactoryService
  ) {
    super();
  }

  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.UPDATE_REGISTRATION;
  }

  async loadData() {
    const data = await this.updateRegistrationFactory.getService(this.dataOrigin).getUserRegistration();
    const newData = UserRegistrationParseData.formatToRegistrationJourney(data, this.getName());
    this.registratioJourney = newData;
    this.setTrack();
    localStorage.setItem("cache-native", JSON.stringify(newData));
    return Promise.resolve(newData);
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    throw new Error("Method not implemented.");
  }

  isBackHeader() {
    return false;
  }

  setTrack() {
    if (
      this.registratioJourney.data?.errorData?.code !== undefined ||
      this.registratioJourney.data?.errorData?.data?.statuscode !== undefined ||
      (this.registratioJourney.data?.personalData === undefined &&
        this.registratioJourney.data?.address === undefined &&
        this.registratioJourney.data?.maritalStatus === undefined &&
        this.registratioJourney.data?.professionalData === undefined &&
        this.registratioJourney.data?.incomeEquity === undefined)
    ) {
       return (this.track = [
         new TrackInfo("overview-error", ["overview-error", "overview-error"]),
       ]);
    }

    if (this.registratioJourney.data?.situacao?.redireciona_app_itau)
      {
       return (this.track = [
         new TrackInfo("overview-user-not-editable", ["overview-validated","overview-user-not-editable"]),
       ]);
      }

    if (!this.registratioJourney.data?.idInvestor) {
      return (this.track = [
        new TrackInfo("broker-registration", ["broker-registration"]),
      ]);
    }
  }
}
